import { uniqueId } from 'lodash-es';

/**
 * Returns an insecure hash code from a string
 * @param  {object | string | null | undefined} val The value to hash (objects are JSON-stringified).
 * @return {string}    A 32-bit hash as a string
 * @see https://stackoverflow.com/a/8831937
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
export const uniqueIdentifierHash = (val: object | string | null | undefined): string => {
  if (val === null || val === undefined) {
    return uniqueId();
  }

  const strVal = typeof val === 'string' ? val : JSON.stringify(val);

  let hash = 0;
  for (let i = 0, len = strVal.length; i < len; i++) {
    const chr = strVal.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash.toString();
};
